var whisListRemoveLinks = document.getElementsByClassName('product-remember__remove');

if (whisListRemoveLinks.length) {
    var request = new XMLHttpRequest();

    request.onreadystatechange = function() {
        if(request.readyState === 4) {
            if(request.status === 200) {
                location.reload();
            } else {
                //TODO: show error ??
            }
        }
    };

    for (var i = 0; i < whisListRemoveLinks.length; i++) {
        whisListRemoveLinks[i].addEventListener('click', onProductRemoveFromWhisList);
    }
}

function onProductRemoveFromWhisList(e) {
    e.preventDefault();

    var type = 'DELETE';
    var url = this.getAttribute('data-remove-url');

    request.open(type, url);
    request.setRequestHeader('Content-Type', 'application/json');
    request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    request.send();
}
